<template>
  <div>
    <h1 v-if="fitburstItems.length !== 0">Showing Fitburst Results</h1>
    <b-button-group class="float-sm-left" size="sm">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/fitburst.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <b-button v-b-modal.fitburst-modal>Rerun Fitburst</b-button>
      <b-button variant="info" href="https://frb.chimenet.ca/workflow/buckets/intensity-fitburst" target="_blank">Monitor Job in Workflow Web</b-button>
      <b-button variant="success" href="https://frb.chimenet.ca/workflow/results/intensity-fitburst" target="_blank">Check Job Results</b-button>
    </b-button-group>
    <b-button variant="dark" size="sm" @click="unsaveParameters('intensity-fitburst')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('intensity-fitburst')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('intensity-fitburst')">Flag for Pipeline Expert</b-button>
    <b-button class="float-sm-right" variant="warning" size="sm" @click="badParameters('intensity-fitburst')">Bad Data</b-button>
    <p v-if="rerunfitburst === true" style="color: green">
      Fitburst job was successfully deployed for this event.
    </p>
    <div v-for="(round, index) in fitburstItems" :key="index" style="margin-top: 50px">
      <h4> Round {{ index + 2 }} (Last Processed on: {{ round['processedAt'] }})</h4>
      <p style="color: red;">{{ round['showText'] }}</p>
      <b-row v-if="round['fitData']['pipeline']['status'] === 'SUCCESS'">
        <b-col md="3">
          <h3>Publicaion</h3>
          <b-img-lazy width='250px' fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['pubplot']}`"/>
        </b-col>
        <b-col md="3">
          <h3>Data</h3>
          <b-img-lazy width='300px' fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['plot']}`"/>
        </b-col>
        <b-col md="3">
          <h3>Correlations</h3>
          <b-img-lazy width='250px' fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['correlations']}`"/>
        </b-col>
        <b-col md="3" style="margin-top: 0px">
          <font size="2" >
          <table border="0">
            <tr align="left">
              <td> DM: </td>
              <td> {{ round['fitData']['sub_burst_dm'] }} +/- {{ round['fitData']['sub_burst_dm_error'] }} </td>
            </tr>
            <tr v-if="round['fitData']['pipeline']['logs'].split(' ')[1] == 3" align="left">
              <td> Scattering Timescale:  </td>
              <td> {{ round ['fitData']['sub_burst_scattering_timescale'] }} +/- {{ round ['fitData']['sub_burst_scattering_timescale_error'] }} </td>
            </tr>
            <!--<tr v-if="round['fitData']['pulse_model'] === 'Spectral'">
              <td>Pulse Model</td>
              <td> Spectral </td>
            </tr>
            <tr v-else align="left">
              <td>Pulse Model : </td>
              <td> Gaussian </td>
            </tr>-->
            <tr v-if="round['fitData']['pulse_model'] === 'Spectral'" align="left">
              <td> Spectral Index: </td>
              <td> {{ round ['fitData']['sub_burst_spectral_index'] }} +/-  {{ round ['fitData']['sub_burst_spectral_index_error'] }}</td>
            </tr>
            <tr v-else align="left">
              <td>Mean Frequency</td>
              <td>{{ round ['fitData']['frequency_mean'] }} +/-  {{ round ['fitData']['frequency_mean_error'] }}</td>
            </tr>
            <tr v-if="round['fitData']['pulse_model'] === 'Spectral'" align="left">
              <td> Spectral Running: </td>
              <td> {{ round ['fitData']['sub_burst_spectral_running'] }} +/-  {{ round ['fitData']['sub_burst_spectral_running_error'] }}</td>
            </tr>
            <tr v-else align="left">
              <td>Frequency Width</td>
              <td>{{ round ['fitData']['frequency_width'] }} +/-  {{ round ['fitData']['frequency_width_error'] }}</td>
            </tr>
            <tr align="left">
              <td> Width: </td>
              <td> {{ round ['fitData']['sub_burst_width'] }} +/- {{ round['fitData']['sub_burst_width_error'] }}</td>
            </tr>
            <tr align="left">
              <td> SNR: </td>
              <td> {{ round ['fitData']['snr'] }} </td>
            </tr>
            <tr align="left" v-if="index===1">
              <td> f-test: </td>
              <td> {{ round ['fitData']['ftest_statistic'] }} </td>
            </tr>
          </table>
        </font>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-container>
          <p>{{ round['fitData']['pipeline']['logs'] }}</p>
        </b-container>
      </b-row>
      <details style="text-center" v-if="index===1">
          <summary>Show other diagnostic plots</summary>
            <b-img-lazy width="300px" fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['peakplot']}`"/>
      </details>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'rerunfitburst',
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'fitburstItems'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/fitburst.vue